// 导入封装好的axios
import axios from "../../http/axios"; // 导入http中创建的axios实例
import base from "../base"; // 导入接口域名列表

const loginhome = {
  // 登录接口
  loging(params) {
    return axios.post(`${base.spurl}/login`, params);
  },
}

// 统一导出
export default loginhome;